import { render, staticRenderFns } from "./xietongSp.vue?vue&type=template&id=132fa06a"
import script from "./xietongSp.vue?vue&type=script&lang=js"
export * from "./xietongSp.vue?vue&type=script&lang=js"
import style0 from "./xietongSp.vue?vue&type=style&index=0&id=132fa06a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports